/* Card videos load on intent, not on sight.
 *
 * The poster image carries the card until someone shows interest. Only then is
 * a <source> attached and the video loaded. Before this, every card video on a
 * collection page downloaded its full 1080p file on scroll: 7.62 MB measured on
 * /collections/sheet alone, for elements roughly 300 px wide.
 *
 * Rewritten 2026-09-01 after PageSpeed attributed 315 ms of main thread time to
 * this file, only 56 ms of which was evaluation. The cost was a MutationObserver
 * watching document.documentElement with subtree:true, which runs on every DOM
 * mutation anywhere on the page. On a page with this much third-party script
 * that is thousands of callbacks.
 *
 * It now uses event delegation instead: three passive listeners on the document,
 * no observer, no per-element binding, and no work at all until a pointer or
 * touch actually reaches a card. Setup is constant time regardless of how many
 * cards exist or how much other script mutates the page.
 */
(function () {
  'use strict';
  var SEL = 'video.card-video-on-intent';

  function load(v) {
    if (!v || v.dataset.cardVideoLoaded) return;
    v.dataset.cardVideoLoaded = '1';
    var s = document.createElement('source');
    s.src = v.dataset.cardVideo;
    s.type = v.dataset.cardVideoType || 'video/mp4';
    v.appendChild(s);
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* refused, the poster stays */ });
  }

  /* Find the card video associated with whatever was interacted with, without
     walking the whole tree: closest() up to the card, then one query down. */
  function videoFor(target) {
    if (!target || target.nodeType !== 1) return null;
    if (target.matches && target.matches(SEL)) return target;
    var card = target.closest && target.closest('[data-product-grid], .image-wrapper');
    return card ? card.querySelector(SEL) : null;
  }

  function onIntent(e) {
    var v = videoFor(e.target);
    if (v) load(v);
  }

  /* mouseover rather than mouseenter: mouseenter does not bubble, so it cannot
     be delegated. touchstart covers phones and tablets. focusin covers keyboard. */
  document.addEventListener('mouseover', onIntent, { passive: true });
  document.addEventListener('touchstart', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent, { passive: true });

  /* Pausing on the way out is a nicety, and only ever touches a video that has
     already been loaded, so it costs nothing on pages without card videos. */
  document.addEventListener('mouseout', function (e) {
    var v = videoFor(e.target);
    if (v && v.dataset.cardVideoLoaded && !v.paused) {
      try { v.pause(); } catch (err) {}
    }
  }, { passive: true });
})();
